import { Grid, Divider } from '@material-ui/core';
import useScrollButtonState from '@ncr-retail/hooks/build/useScrollButtonState/useScrollButtonState';
import React from 'react';
import { useSelector } from 'react-redux';
import { SizeType } from 'src/common/enumerations/cashier-preference-level';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { IElectronicJournalRecord } from 'src/common/interfaces/states/IElectronicJournalRecord';
import { AppState } from 'src/common/redux/configure-store';
import { styles } from './action-window-styles';
import { BaseContainer } from './bottom-container/base-container';
import { Total } from './bottom-container/summary/total';

const ActionWindowTaxExemptionLines: React.FC<Props> = (props: Props): JSX.Element => {
  const { items, isKeypadVisible, toggleKeypad } = props;
  const [{ currentPage, lastPage, onPageChanged }, scrollRef] = useScrollButtonState();
  const buttonSize = useSelector(
    (state: AppState): SizeType => state.cashierPreferences?.buttonZoomLevel || 0,
  );
  const textSize = useSelector(
    (state: AppState): SizeType => state.cashierPreferences?.textZoomLevel || 0,
  );
  const classes = styles({ buttonSize, textSize });
  let totalQuantity = 0;
  return (
    <>
      <Grid
        className={`fullWidth ${classes.taxExemptionContainer}`}
        data-testid='action-window-tax-exemption-container'
      >
        <div
          ref={scrollRef}
          className={`verticalScroll fullWidth ${classes.taxExemptionScrollContainer}`}
          data-testid='action-window-tax-exemption-scroll-container'
        >
          {items
            .filter(({ Taxes }) => Taxes?.some(({ exemptAmount }) => exemptAmount))
            .map((item, index) => {
              const taxExempted =
                item.Taxes?.reduce((total, { exemptAmount }) => total + (exemptAmount ?? 0), 0) ??
                0;
              const quantity = [...Array(item.Quantity)];
              totalQuantity += item.Quantity ?? 0;
              return quantity.map(ind => (
                <Grid
                  key={`${item.SequenceNumber}${ind}`}
                  container
                  className={`${classes.taxExemptionLine}`}
                >
                  <Grid item>
                    <span data-testid={`action-window-tax-exemption-description-${index}`}>
                      {item.Description || item.Name}
                    </span>
                  </Grid>
                  <Grid item className={classes.autoLeftMargin}>
                    <span data-testid={`action-window-tax-exemption-amount-${index}`}>
                      {`${convertCurrency(-taxExempted / (item?.Quantity ?? 1))}`}
                    </span>
                  </Grid>
                </Grid>
              ));
            })}
        </div>
      </Grid>
      <Grid
        className={`fullWidth ${classes.pushToBottom}  ${lastPage > 1 ? classes.taxMinHeight : ''}`}
      >
        <BaseContainer
          isKeypadVisible={isKeypadVisible}
          toggleKeypad={toggleKeypad}
          currentPage={currentPage}
          totalPages={lastPage}
          updateCurrentPageHandler={onPageChanged}
        ></BaseContainer>
        <Divider />
        <Grid container direction='row' className={`${classes.totalContanier}`}>
          <Grid>
            <Total
              totalUnits={totalQuantity}
              isSelectedItemReturnItem={false}
              totalPages={lastPage}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

interface Props {
  items: IElectronicJournalRecord[];
  isKeypadVisible: boolean;
  toggleKeypad: () => void;
}

export default ActionWindowTaxExemptionLines;
